// extracted by mini-css-extract-plugin
export default {"transparentBorder":"contextual-menu-dropdown-option-module__transparentBorder--ozSWp"};